import { render, staticRenderFns } from "./NotificationPermissionTrigger.vue?vue&type=template&id=779778b9"
import script from "./NotificationPermissionTrigger.vue?vue&type=script&lang=js"
export * from "./NotificationPermissionTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports